import { Box, Button, ButtonBase } from '@mui/material'
import { styled } from '@mui/material/styles'

export const UserMenuHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(theme.tokens.spacing.xs),
  padding: theme.spacing(theme.tokens.spacing.sm, theme.tokens.spacing.md),
  minWidth: 200,
  pointerEvents: 'none',
}))

export const SidebarContainer = styled(Box)(({ theme }) => ({
  width: 240,
  minWidth: 240,
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  borderRight: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(theme.tokens.spacing.md, 1.5),
}))

export const NavItemButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  padding: theme.spacing(theme.tokens.spacing.sm, theme.tokens.spacing.md),
  gap: theme.spacing(theme.tokens.spacing.sm),
  borderRadius: theme.shape.borderRadius,
  fontWeight: active ? 600 : 400,
  color: active ? theme.palette.primary.contrastText : theme.palette.text.secondary,
  backgroundColor: active ? theme.palette.primary.main : 'transparent',
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.dark : theme.palette.action.hover,
  },
  '& .MuiButton-startIcon': {
    marginRight: 0,
    color: active ? theme.palette.primary.contrastText : 'inherit',
  },
}))

export const UserProfileButton = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(theme.tokens.spacing.md),
  padding: theme.spacing(theme.tokens.spacing.xs, theme.tokens.spacing.sm),
  borderRadius: theme.shape.borderRadius,
  width: '100%',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))
